document.addEventListener('DOMContentLoaded', () => {
  const wrapPriceHelperDiv = () => {
    const priceHelper = document.querySelector('.price-helper')
    if (priceHelper && !priceHelper.parentElement.classList.contains('price-helper-wrapper')) {
      const woocommerceVariation = document.querySelector('.woocommerce-variation')
      const wrapper = document.createElement('div')
      wrapper.className = 'price-helper-wrapper'
      priceHelper.parentElement.insertBefore(wrapper, priceHelper)
      if (woocommerceVariation) {
        wrapper.appendChild(woocommerceVariation)
      }
      wrapper.appendChild(priceHelper)
    }
  }

  // Observe DOM changes
  const observer = new MutationObserver(() => {
    wrapPriceHelperDiv()
  })
  observer.observe(document.body, { childList: true, subtree: true })

  // Initial run
  wrapPriceHelperDiv()

  var summary = document.querySelector('.summary')
  // Get the tabs element
  var tabs = document.querySelector('.custom-woo-tabs')
  if (!tabs) {
    return
  }

  // Calculate the top position based on the summary's height
  var topPosition = summary.offsetHeight > 800 ? '70%' : '52%'

  // Apply the top position to the tabs
  tabs.style.top = topPosition
})
